import React, { ReactElement } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "semantic-ui-react";

import useTypedSelector from "hooks/useTypedSelector";
import { closeLoginModal } from "redux/auth/authSlice";
import { selectLoginModalOpen } from "redux/selectors/authSelectors";
import LoginForm from "./LoginForm";

/**
 * App-wide login modal, driven by Redux so anything can open it
 * (the profile button, or the app when a session expires).
 */
export default function LoginModal(): ReactElement {
  const dispatch = useDispatch();
  const open = useTypedSelector(selectLoginModalOpen);

  return (
    <Modal
      open={open}
      onClose={() => dispatch(closeLoginModal())}
      size="tiny"
      closeIcon
    >
      <Modal.Header>Log in to Aviation Resources</Modal.Header>
      <Modal.Content>
        <LoginForm />
      </Modal.Content>
    </Modal>
  );
}
